var render = function render(){
  var _vm$getEvent, _vm$getEvent2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-overlay', {
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_vm.getEvent ? _c('b-card', [_c('b-row', {
    staticClass: "mb-3",
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', [_c('font-awesome-icon', {
    staticClass: "arrow-left",
    attrs: {
      "icon": "arrow-left"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push(`/event/${_vm.eventId}`);
      }
    }
  }), _c('h4', {
    staticClass: "d-inline"
  }, [_vm._v(" " + _vm._s((_vm$getEvent = _vm.getEvent) === null || _vm$getEvent === void 0 ? void 0 : _vm$getEvent.name) + " ")])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "xl": "4"
    }
  }, [_c('form-selector', {
    attrs: {
      "options": _vm.getInvitableUsersAsOptions,
      "default-value": 'event-editors.selector-default'
    },
    model: {
      value: _vm.userId,
      callback: function ($$v) {
        _vm.userId = $$v;
      },
      expression: "userId"
    }
  })], 1), _c('b-col', {
    attrs: {
      "xl": "2"
    }
  }, [_c('b-button', {
    staticClass: "invite-button w-100 mb-3",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addEditor
    }
  }, [_c('img', {
    staticClass: "mb-1",
    attrs: {
      "src": require(`@/assets/customer-project/invite.svg`)
    }
  }), _vm._v(" " + _vm._s(_vm.$t('event-editors.add-editor')) + " ")])], 1), _c('b-col', {
    attrs: {
      "xl": "2"
    }
  }, [_c('event-editor-invite-button', {
    attrs: {
      "event-id": _vm.eventId,
      "event": _vm.getEvent
    },
    on: {
      "invited": _vm.refreshUsersAfterInvite
    }
  })], 1)], 1), _c('b-row', [_c('b-col', [_c('event-editors-table', {
    attrs: {
      "event-role": (_vm$getEvent2 = _vm.getEvent) === null || _vm$getEvent2 === void 0 ? void 0 : _vm$getEvent2.role,
      "invited-users": _vm.getInvitedUsers
    },
    on: {
      "onRemove": _vm.onRemove
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }